
// Others
import {Component, Vue} from 'vue-property-decorator';
import ContratoService from "@/service/contrato.service";
// Models
import ContratoModel from "@/models/contratos/contrato.model";
// Components
import DadosContratoComponent from "@/components/DadosContratoComponent.vue";
import FormatUtil from "@/util/format.util";
import {namespace} from "vuex-class";
import {MapActionsLoading} from "@/store/modules/loading/map-actions.loading";

const loading = namespace('loading');

@Component({
  name: "ContratoViewComponent",
  components: {
    DadosContratoComponent
  }
})
export default class ContratoViewComponent extends Vue {

  @loading.Action(MapActionsLoading.OPEN_LOADING) openLoading;
  @loading.Action(MapActionsLoading.CLOSE_LOADING) closeLoading;

  private step = 1;
  private contrato = new ContratoModel();

  async mounted() {
    const idContrato = this.$route.params.id;
    if (idContrato) {
      this.openLoading();
      this.contrato = await ContratoService.get(idContrato);
      this.closeLoading();
    }
  }

}
